import * as React from 'react';
import { Subscribe } from 'unstated';

import StateContainer from '../StateContainer';
import ProductImages from './ProductImages';
import AttributesQuery from '../../../../components/Query/Attributes';

export interface IProductImagesTabProps {
    container: StateContainer;
    removeImage: (obj: any) => void;
    shouldUpdate: boolean;
}

export class ProductImagesTab extends React.Component<IProductImagesTabProps> {
    
    public shouldComponentUpdate() {
        return this.props.shouldUpdate;
    }

    public render() {
        const { container } = this.props;

        return (
            <AttributesQuery>
                {({ attributes }: any) => {
                    if (attributes.attributes) {
                        return (
                            <Subscribe to={[container]}>
                                {productDetail => (
                                    <ProductImages
                                        removeImage={(obj: any) => this.props.removeImage(obj)}
                                        onChange={(val: any) => container.onChange('images', val)}
                                        productImages={productDetail.state.product.images} // all images for product, no filtering
                                        productId={productDetail.state.product.id}
                                        uniqueVisualCombinations={container.getUniqueVisualCombinations(attributes.attributes)}
                                    />
                                )}
                            </Subscribe>
                        );
                    }

                    return null;
                }}
            </AttributesQuery>
        );
    }
}



// WEBPACK FOOTER //
// ./src/scenes/Products/ProductDetail/ProductImagesTab/ProductImagesTab.tsx